// extracted by mini-css-extract-plugin
module.exports = {"confirm-price-changes":"ConfirmPriceChanges_confirm-price-changes__17DL-","loading":"ConfirmPriceChanges_loading__2_12L","no-changes":"ConfirmPriceChanges_no-changes__5XSUF"};